<template>
  <hypto-popup :title="`${capitalize(type)} List`" :footer="false">
    <template v-slot:body>
      <div v-for="(obj, index) in renderList" :key="index">
        <div class="title" @click="toggle(index)" v-if="renderList.length > 1">
          <h5>{{capitalize(type)}} - {{obj.id}}</h5>
          <i class="fa" :class="{'fa-angle-down': !obj.show, 'fa-angle-up': obj.show}" />
        </div>

        <div v-if="obj.show || renderList.length === 1" class="content">
          <div
            v-for="(data, dataIndex) in obj.popup"
            :key="dataIndex"
            class="row"
          >
            <h6>
              {{data.field}}
            </h6>
            <p>
              {{data.value}}
              <i class="fa fa-info-circle" v-if="data.field === 'Beneficiary Account IFSC' && obj.bene_initiated_account_ifsc !== '-'">
                <md-tooltip md-direction="top">Due to Bank Merger, refund amount has been settled to {{obj.bene_initiated_account_ifsc}}</md-tooltip>
              </i>
            </p>
          </div>

          <div v-if="extras.show">
            <h5>{{extras.title}}</h5>
            <div
              v-for="(data, dataIndex) in obj[extras.key]"
              :key="dataIndex + '_Pay'"
              class="row"
            >
              <h6>
                {{data.field}}
              </h6>
              <p>
                {{data.value}}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="empty-info" v-if="renderList.length === 0">
        <p>No {{type}} found</p>
      </div>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import { capitalize } from '@/utils/helpers'

export default {
  name: 'ExpandCollapseList',
  components: { HyptoPopup },
  props: {
    list: Array,
    type: {
      type: String,
      default: 'refunds'
    },
    extras: {
      type: Object,
      default: () => {
        return {
          show: false
        }
      }
    }
  },
  data () {
    return {
      renderList: []
    }
  },
  created () {
    this.renderList = this.list.map(e => {
      e.show = false
      return e
    })
  },
  methods: {
    capitalize,
    toggle (index) {
      this.renderList[index].show = !this.renderList[index].show
      this.renderList = [...this.renderList]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/rowDetails.scss';

  .title {
    border-bottom: 2px solid $grey-outline;
    padding: 12px 10px;
    @include custom-flex(space-between);
    cursor: pointer;
    grid-gap: 15px;

    h5 {
      @include highlight-text($primary, 15px);
      text-align: left;
    }
    i {
      color: $primary;
    }
  }

  .content {
    padding: 10px;
    background: #f6f8fa;

    h5 {
      text-align: left;
      color: $secondary;
      font-size: 14px;
      border-bottom: 1px solid rgba(228, 231, 231, 1);
      padding-bottom: 10px;
      margin-bottom: 10px;
      margin-top: 30px;
    }

    .row {
      i {
        cursor: pointer;
        color: $primary;
        margin-left: 5px;
      }
    }
  }

  .empty-info {
    text-align: center;
    padding: 15px;

    p {
      @include normal-text($secondary, 15px);
    }
  }

  .md-tooltip {
    width: 300px !important;
  }

  @media screen and (max-width: $mobile) {
    .md-tooltip {
      width: 250px !important;
    }
  }
</style>
